import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import React from "react";
import { FaRegFileWord } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Item from "../../components/Item";

const IntegrateMain = () => {
    const navigate = useNavigate();

    const apiIntegrations = [
        {
            name: "Dictionary API",
            path: "/admin/system/integrate/dictionary",
            icon: FaRegFileWord,
            description: "Free Dictionary API for word definitions, pronunciations, and meanings. Provides comprehensive word information for English words."
        },
        {
            name: "Datamuse API",
            path: "/admin/system/integrate/datamuse",
            icon: FaRegFileWord,
            description: "Datamuse API for word associations, wildcard searches, and word relationships. Useful for finding related words and patterns."
        },
        {
            name: "Guardian API",
            path: "/admin/system/integrate/guardian",
            icon: FaRegFileWord,
            description: "Guardian API integration for accessing news articles and content. Provides access to Guardian newspaper content and articles."
        },
        {
            name: "Cambridge API",
            path: "/admin/system/integrate/cambridge",
            icon: FaRegFileWord,
            description: "Cambridge Dictionary API for authoritative word definitions and examples. Provides high-quality dictionary content from Cambridge University Press."
        },
        {
            name: "Open Library API",
            path: "/admin/system/integrate/openlibrary",
            icon: FaRegFileWord,
            description: "Open Library API for accessing book information and library data. Provides comprehensive book metadata and information."
        },
        {
            name: "Pi Dictionary API",
            path: "/admin/system/integrate/puzzle-interact-api",
            icon: FaRegFileWord,
            description: "Puzzle Interact Dictionary API for custom word definitions and puzzle-specific word data. Internal dictionary service for puzzle applications."
        },
        {
            name: "Word Network",
            path: "/admin/system/integrate/word-network",
            icon: FaRegFileWord,
            description: "Word Network visualization and analysis tool. Creates semantic and syntactic relationships between words for puzzle generation."
        }
    ];

    const handleNavigate = (path) => {
        navigate(path);
    };

    return (
        <Box sx={{ p: 3 }}>
            <Item>
                <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4, fontWeight: 600, color: "#1976d2" }}>
                    API Integrations
                </Typography>
                <Typography variant="body1" paragraph sx={{ mb: 4, color: "text.secondary" }}>
                    Manage and access various API integrations for dictionary services, word networks, and content sources.
                </Typography>

                <Grid container spacing={3}>
                    {apiIntegrations.map((api, index) => {
                        const IconComponent = api.icon;
                        return (
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                                <Card
                                    sx={{
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                                        "&:hover": {
                                            transform: "translateY(-4px)",
                                            boxShadow: 4
                                        },
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handleNavigate(api.path)}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            minWidth: "120px",
                                            width: "120px",
                                            backgroundColor: "#f5f5f5",
                                            borderRight: "1px solid #e0e0e0"
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            sx={{
                                                minWidth: "80px",
                                                height: "80px",
                                                borderRadius: "50%",
                                                backgroundColor: "#1976d2",
                                                "&:hover": {
                                                    backgroundColor: "#1565c0"
                                                },
                                                p: 0
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleNavigate(api.path);
                                            }}
                                        >
                                            <IconComponent size="2em" color="white" />
                                        </Button>
                                    </Box>
                                    <CardContent sx={{ flex: 1, p: 3 }}>
                                        <Typography variant="h6" component="h2" gutterBottom sx={{ fontWeight: 600, mb: 1.5 }}>
                                            {api.name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                                            {api.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Item>
        </Box>
    );
};

export default IntegrateMain;

